import styled from 'styled-components'

export const StyledSlidingPanelFooter = styled.div`
  width: 100%;
`
